/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateTagsControllerFindAllQueryResponse, TemplateTagsControllerFindAllQueryParams, TemplateTagsControllerFindAll401, TemplateTagsControllerFindAll403 } from "../../models/checklistsController/TemplateTagsControllerFindAll";

function getTemplateTagsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-template-tags` as const }  
  return res
}

/**
 * @summary List all template tags
 * {@link /api/v1/checklist-template-tags}
 */
export async function templateTagsControllerFindAll(params?: TemplateTagsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateTagsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateTagsControllerFindAll401 | TemplateTagsControllerFindAll403>, unknown>({ method : "GET", url : getTemplateTagsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}